import React, { useState } from "react";
import { Avatar, Dropdown, Popover } from "antd";
import { momentit } from "../../../utils";
import { ReactComponent as ViewIcon } from "../../../Icons/totalView.svg";
import { ReactComponent as HeartIcon } from "../../../Icons/heart.svg";
import { ReactComponent as HeartSelectedIcon } from "../../../Icons/heartSelect.svg";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as PdfWhiteIcon } from "../../../Icons/pdfWhiteIcon.svg";
import { fetchAttachmentURL, getQuestionDraftData, markUnmarkFavourite } from "../../../API/api";
import { ReactComponent as InternalIcon } from "../../../Icons/internal.svg";
import { ReactComponent as DownloadIcon } from "../../../Icons/download.svg";
import Button2 from "../../Button2/Button2";
import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import TooltipComp from "../../ToolTip/TooltipComp";
import { useLocation, useNavigate } from "react-router-dom";
import { DeleteOutlineOutlined, EditOutlined, FavoriteBorderOutlined, LocalFireDepartment, PeopleAltOutlined } from "@mui/icons-material";
import { CURRENT_ROLE } from "../../../API/url";
import { Actions } from "../../../Action";
import { bindActionCreators } from "redux";

export default function QuestionBox({ question }) {
  // console.log("new question",question)
  const searchState = useSelector((state) => state.search);
  const currentPath = useLocation()
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const [isFavorite, setFavorite] = useState(question.favourite);
  const { recommendData, preservePreviousRecommendData, filteredOrigSearchData, advanceFilterModalToggle, getSelectedQuestion, markedTrendingData, markedAnsweredData, markedFavData, markedSharedByData, markedSharedWithData, updateKeyTagData, questionDataForEditor, updateAnswerTextForEditor, updateSubmissionTypeForEditor, updateAttachmentForEditor, updateCheckBoxValForEditor, filteringSearchData, getSeekerAttachment } =
    bindActionCreators(Actions, dispatch);
  const editorState = useSelector((state) => state.editor);
  const navigate = useNavigate()
  const onCLickFavorite = (key, flag) => {
    markUnmarkFavourite(key.origQuestionUuid).then((res) => {
      if (res === undefined) return;
      setFavorite(flag);
      searchState.expertData.filter(obj => {
        if (obj.origQuestionUuid === key.origQuestionUuid) {
          obj.favourite = flag;
        }
      })
    });
  };
  
  const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom:'5px'
    // paddingLeft: "7px",

  };
  const textStyles = {
    fontSize: "24px",
    color: "#2A364A",
    lineHeight: "32px",
    fontWeight: "400",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };
  const confidenceStyles1 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #F59B00",
    borderRadius: "6px",
    backgroundColor: "#F59B00",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };
  const confidenceStyles2 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #00A3FF",
    borderRadius: "6px",
    backgroundColor: "#00A3FF",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };

  const renderAttachemnt = (arr) => {
    return (
      <div>
        {arr.map((item, index) => (
          <div className="mb-1">
            {" "}
            <AttachmentBox key={index} attachment={item} />
          </div>
        ))}
      </div>
    );
  };

  const items = [
    {
      key: '1',
      label: (
        <a>
          <EditOutlined fontSize="24" style={{ margin: '3px' }} />
          Edit
        </a>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: '2',
      label: (
        <a>
          <DeleteOutlineOutlined fontSize="24" style={{ margin: '3px' }} />
          Delete
        </a>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: '3',
      label: (
        <a>
          <FavoriteBorderOutlined fontSize="24" style={{ margin: '3px', color: question.favourite && '#FF6A00' }} />
          Favorite
        </a>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: '4',
      label: (
        <a>
          <PeopleAltOutlined fontSize="24" style={{ margin: '3px' }} />
          Add to Watchlist
        </a>
      ),
    },
    {
      type: 'divider',
    },
  ]

  const isAnsweredByMe = (arr) => {
    let id = ""
    arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        updateCheckBoxValForEditor({ flag: obj.internal, key: "internal" });
        updateCheckBoxValForEditor({ flag: obj.privacy, key: "isUpdateKB" });
        id = obj.answerUuid;
      }
    })
    return id;
  }

  const isAnsweredByMeAttachment = (arr) => {
    // console.log("answers", arr)
    let text = []
    arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        text = obj.attachments;
      }
    })
    return text;
  }

  const appendInlineImageInText = async (arr) => {
    let newArr = await arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        if (obj.inlineImages.length > 0) {
          for (let i = 0; i < obj.inlineImages.length; ++i) {
            let pld = { name: obj.inlineImages[i] }
            fetchAttachmentURL(pld).then(res => {
              if (res === undefined) return;
              if (obj.inlineImages[i].includes(".png")) {
              } else {
                let imgTag = `<img style='max-width:50%' src=${res.data.data.src
                  }></img>`;

                let replacedContent = obj.inlineImages[i];
                obj.answerCopy = obj.answerCopy.replaceAll(
                  replacedContent,
                  imgTag
                );
                updateAnswerTextForEditor(obj.answerCopy);
              }
            })
          }
        }

        return obj;
      }
    })
    updateAnswerTextForEditor(newArr.length === 0 ? "" : newArr[0].answerCopy);
  }
  const convertStringToEpoch = (dt) => {
    let date = Date.parse(dt);
    return date;
  }
  
  const editAnswer = () => {
    // console.log("question", question)
    let data = question;
    if (data.questionText === undefined) {
      data.questionText = data.question;
    }
    if (currentPath.pathname.includes('/search')) {
      data.questionUuid = data.origQuestionUuid;
    }
    if (data.seekerAttachments && data.seekerAttachments !== null) {
      getSeekerAttachment(data.seekerAttachments)
    }
    updateAttachmentForEditor(isAnsweredByMeAttachment(data.answers))
    let isAnswerUuid = isAnsweredByMe(data.answers);
    editorState.answerUuid = isAnsweredByMe(data.answers);
    updateSubmissionTypeForEditor(isAnswerUuid === '' ? 'answer' : 'update');
    data.questionPostedTimestamp = data.questionPostedTimestamp === undefined ? data.postedTimestamp : data.questionPostedTimestamp;
    data.questionStatus = 'answered';
    data.questionPostedTimestamp = typeof (data.questionPostedTimestamp) === 'string' ? convertStringToEpoch(data.questionPostedTimestamp) : data.questionPostedTimestamp;
    questionDataForEditor(data);
    getQuestionDraftData(data.questionUuid).then(res => {
      if (res === undefined) return;
      if (res.data.data.length > 0) {
        updateAnswerTextForEditor(res.data.data[0].answer);
      } else {
        appendInlineImageInText(data.answers);
      }
    })
    navigate('/expertHome/editor');
  }
  return (
    <>
      <div style={infoContainer}>
        <div style={dateInfoStyles}>
          <div style={textStyles}>
            {question.question}
          </div>
          <div style={infoContainer}>
            {question.seekerAttachments && question.seekerAttachments.length > 0 && (
              <Popover title={renderAttachemnt(question.seekerAttachments)}>
                {" "}
                <Button2 onClickFunc={onCLickFavorite}>
                  <DownloadIcon />
                </Button2>
              </Popover>)}
            {question.docType === "expertqa" &&
              (isFavorite ? (
                <div style={{ marginRight: "6px", cursor: "pointer" }}>
                  
                  <TooltipComp title={"Favorite question"}>
                                                      <HeartSelectedIcon
                    onClick={() => onCLickFavorite(question, false)}
                  /> 
                                                    </TooltipComp>
                </div>
              ) : (
                <div style={{ marginRight: "6px", cursor: "pointer" }}>
                  <TooltipComp title={"Favorite question"}>
                  <HeartIcon onClick={() => onCLickFavorite(question, true)} />
                    </TooltipComp>
                </div>
              ))}
            {question.isShowUpdateRequestWarning && <div><TooltipComp title={'Recommended request for update; this answer may not be up-to-date.'}><span><i class="fa fa-exclamation-circle" style={{ fontSize: '22px', color: '#F59B00', marginRight: '5px', cursor: 'pointer' }}></i></span></TooltipComp>
            </div>}
            {!currentPath.pathname.includes('/open') && <div
              style={
                question.confidence ? confidenceStyles2 : confidenceStyles1
              }
            >
              {question.docType === "expertqa" ? (
                "Q&A"
              ) : (
                <>
                  <PdfWhiteIcon style={{ marginBottom: "4px" }} />
                </>
              )}
            </div>}
            {CURRENT_ROLE === 'Expert' && <div>&nbsp;&nbsp;<TooltipComp title={"Edit answer"}><i className="fa fa-edit" style={{ fontSize: '20px', marginTop: '5px', color: '#ACB6C6', cursor: 'pointer' }} onClick={() => editAnswer()}></i></TooltipComp></div>}
          </div>
        </div>
      </div>
      {/* <span style={{color:'#5C667B',fontSize:'12px',fontWeight:400}}>Last Reviewed{" "}{momentit(question.postedTimestamp)}</span> */}
    </>
  );
}
